import { useSelector } from 'react-redux';
import { get } from 'lodash';

import { useNoticeAirportByTask } from '../../../selectors/notices/notices';

export const useNotice = () =>
    useSelector((state) => {
        const { isNotices, recent } = useNoticeAirportByTask();
        const isNoticeAllowed = get(state.routesDeclaration, 'options.allowNotices', false);
        const isNoticePreviewAllowed = get(state.routesDeclaration, 'options.allowNoticesPreview', false);

        return {
            isNoticeAllowed: isNoticeAllowed || isNoticePreviewAllowed,
            isNotices,
            recent,
        };
    });
